import client, { REWARDS_BASE_URL } from 'services/kardAPI';

const fetchWssURL = async () => {
  try {
    const URL = await client.get(`${REWARDS_BASE_URL}/portal/websocket`);
    return URL.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export default fetchWssURL;
